<template>
  <el-dialog :title="title" :visible.sync="show" :append-to-body="true" :width="dialogWidth">
    <!-- 内容区域 -->
    <el-descriptions border :column="1" :labelStyle="labelSytle">
      <el-descriptions-item v-for="item in labels" :key="item.value" :label="item.label">
        <el-descriptions v-if="item.children && item.children.length > 0 && datas[item.childValue]" border :column="1" :labelStyle="labelSytle">
          <el-descriptions-item v-for="it in item.children" :key="it.value" :label="it.label">
            <span v-format="'#,##0.00'">{{ (datas[item.childValue] && datas[item.childValue][it.value]) || 0 }}</span> 元
          </el-descriptions-item>
          <el-descriptions-item label="合计">
            <span v-format="'#,##0.00'">{{ datas[item.value] || 0 }}</span> 元
          </el-descriptions-item>
        </el-descriptions>
        <template v-else>
          <span v-format="'#,##0.00'">{{ datas[item.value] || 0 }}</span> 元
        </template>
      </el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "税额明细",
    },
    dialogWidth: {
      type: String,
      default: "500px",
    },
    labelSytle: {
      type: Object,
      default: () => ({
        width: "120px",
        textAlign: "right",
      }),
    },
    labels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      datas: {},
    };
  },
  methods: {
    // 数据清空
    clear() {},
    open(obj) {
      this.show = true;
      this.datas = obj;
    },
  },
};
</script>
